var _rect, _path, _path2, _path3, _path4, _path5, _g, _path6, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _line12, _path33, _path34, _path35, _path36, _rect2, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeProvideQualitySection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 488,
    height: 424,
    viewBox: "0 0 488 424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 38,
    width: 130,
    height: 170,
    rx: 8,
    fill: "#1E274F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 61C47 59.3431 48.3431 58 50 58H84C85.6569 58 87 59.3431 87 61C87 62.6569 85.6569 64 84 64H50C48.3431 64 47 62.6569 47 61Z",
    fill: "#DAE9F5",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122 61C122 59.3431 123.343 58 125 58H134C135.657 58 137 59.3431 137 61C137 62.6569 135.657 64 134 64H125C123.343 64 122 62.6569 122 61Z",
    fill: "#DAE9F5",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133 134C135.209 134 137 132.209 137 130L137 78C137 75.7909 135.209 74 133 74L51 74C48.7909 74 47 75.7909 47 78L47 130C47 132.209 48.7909 134 51 134L133 134Z",
    fill: "#DAE9F5",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83 188C85.2091 188 87 186.209 87 184L87 152C87 149.791 85.2091 148 83 148L51 148C48.7909 148 47 149.791 47 152L47 184C47 186.209 48.7909 188 51 188L83 188Z",
    fill: "#DAE9F5",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133 188C135.209 188 137 186.209 137 184L137 152C137 149.791 135.209 148 133 148L101 148C98.7909 148 97 149.791 97 152L97 184C97 186.209 98.7909 188 101 188L133 188Z",
    fill: "#DAE9F5",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1112_916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108 97C108 85.6863 108 80.0294 111.515 76.5147C115.029 73 120.686 73 132 73H267V312H132C120.686 312 115.029 312 111.515 308.485C108 304.971 108 299.314 108 288V97Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M269 75H403C408.713 75 412.797 75.0042 415.901 75.4215C418.947 75.831 420.747 76.6051 422.071 77.9289C423.395 79.2528 424.169 81.0532 424.578 84.0992C424.996 87.2028 425 91.2866 425 97V288C425 293.713 424.996 297.797 424.578 300.901C424.169 303.947 423.395 305.747 422.071 307.071C420.747 308.395 418.947 309.169 415.901 309.578C412.797 309.996 408.713 310 403 310H269V75Z",
    fill: "url(#paint0_linear_1112_916)",
    stroke: "#64A4D5",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 442,
    y1: 43,
    x2: 442,
    y2: 158,
    stroke: "#64A4D5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 442,
    y1: 248,
    x2: 442,
    y2: 345,
    stroke: "#64A4D5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 442,
    y1: 176,
    x2: 442,
    y2: 232,
    stroke: "#64A4D5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 438,
    y1: 175,
    x2: 446,
    y2: 175,
    stroke: "#64A4D5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 438,
    y1: 158,
    x2: 446,
    y2: 158,
    stroke: "#64A4D5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 438,
    y1: 232,
    x2: 446,
    y2: 232,
    stroke: "#64A4D5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 438,
    y1: 246,
    x2: 446,
    y2: 246,
    stroke: "#64A4D5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 270,
    y1: 58,
    x2: 459,
    y2: 58,
    stroke: "#64A4D5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 298,
    y1: 41,
    x2: 459,
    y2: 41,
    stroke: "#64A4D5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 298,
    y1: 344,
    x2: 459,
    y2: 344,
    stroke: "#64A4D5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 270,
    y1: 327,
    x2: 459,
    y2: 327,
    stroke: "#64A4D5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132 104C132 101.791 133.791 100 136 100H267V160H136C133.791 160 132 158.209 132 156V104Z",
    fill: "#DAE9F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132 178C132 175.791 133.791 174 136 174H168C170.209 174 172 175.791 172 178V210C172 212.209 170.209 214 168 214H136C133.791 214 132 212.209 132 210V178Z",
    fill: "#DAE9F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132 221C132 219.343 133.343 218 135 218H169C170.657 218 172 219.343 172 221C172 222.657 170.657 224 169 224H135C133.343 224 132 222.657 132 221Z",
    fill: "#EEEEEE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132 231C132 229.343 133.343 228 135 228H161C162.657 228 164 229.343 164 231C164 232.657 162.657 234 161 234H135C133.343 234 132 232.657 132 231Z",
    fill: "#EEEEEE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M215 87C215 85.3431 216.343 84 218 84H244C245.657 84 247 85.3431 247 87C247 88.6569 245.657 90 244 90H218C216.343 90 215 88.6569 215 87Z",
    fill: "#EEEEEE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M251 87C251 85.3431 252.343 84 254 84H280C281.657 84 283 85.3431 283 87C283 88.6569 281.657 90 280 90H254C252.343 90 251 88.6569 251 87Z",
    fill: "#EEEEEE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M268 87C268 85.3431 269.343 84 271 84H280C281.657 84 283 85.3431 283 87C283 88.6569 281.657 90 280 90H271C269.343 90 268 88.6569 268 87Z",
    fill: "#64A4D5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M287 87C287 85.3431 288.343 84 290 84H316C317.657 84 319 85.3431 319 87C319 88.6569 317.657 90 316 90H290C288.343 90 287 88.6569 287 87Z",
    fill: "#64A4D5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M190 221C190 219.343 191.343 218 193 218H227C228.657 218 230 219.343 230 221C230 222.657 228.657 224 227 224H193C191.343 224 190 222.657 190 221Z",
    fill: "#EEEEEE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M190 231C190 229.343 191.343 228 193 228H219C220.657 228 222 229.343 222 231C222 232.657 220.657 234 219 234H193C191.343 234 190 232.657 190 231Z",
    fill: "#EEEEEE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M248 221C248 219.343 249.343 218 251 218H267C268.657 218 270 219.343 270 221C270 222.657 268.657 224 267 224H251C249.343 224 248 222.657 248 221Z",
    fill: "#EEEEEE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M248 231C248 229.343 249.343 228 251 228H266C267.657 228 269 229.343 269 231C269 232.657 267.657 234 266 234H251C249.343 234 248 232.657 248 231Z",
    fill: "#EEEEEE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M190 178C190 175.791 191.791 174 194 174H226C228.209 174 230 175.791 230 178V210C230 212.209 228.209 214 226 214H194C191.791 214 190 212.209 190 210V178Z",
    fill: "#DAE9F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M132 251C132 249.343 133.343 248 135 248H169C170.657 248 172 249.343 172 251C172 252.657 170.657 254 169 254H135C133.343 254 132 252.657 132 251Z",
    fill: "#EEEEEE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M132 87C132 85.3431 133.343 84 135 84H161C162.657 84 164 85.3431 164 87C164 88.6569 162.657 90 161 90H135C133.343 90 132 88.6569 132 87Z",
    fill: "#64A4D5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M132 261C132 259.343 133.343 258 135 258H227C228.657 258 230 259.343 230 261C230 262.657 228.657 264 227 264H135C133.343 264 132 262.657 132 261Z",
    fill: "#EEEEEE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M132 271C132 269.343 133.343 268 135 268H227C228.657 268 230 269.343 230 271C230 272.657 228.657 274 227 274H135C133.343 274 132 272.657 132 271Z",
    fill: "#EEEEEE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M132 292C132 288.686 134.686 286 138 286H158C161.314 286 164 288.686 164 292C164 295.314 161.314 298 158 298H138C134.686 298 132 295.314 132 292Z",
    fill: "#64A4D5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M146 140C146 136.686 148.686 134 152 134H172C175.314 134 178 136.686 178 140C178 143.314 175.314 146 172 146H152C148.686 146 146 143.314 146 140Z",
    fill: "#64A4D5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M146 120C146 116.686 148.686 114 152 114H198C201.314 114 204 116.686 204 120C204 123.314 201.314 126 198 126H152C148.686 126 146 123.314 146 120Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M248 252C248 249.791 249.791 248 252 248H270V298H252C249.791 298 248 296.209 248 294V252Z",
    fill: "#DAE9F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M248 178C248 175.791 249.791 174 252 174H267V214H252C249.791 214 248 212.209 248 210V178Z",
    fill: "#DAE9F5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M308 178C308 176.895 308.895 176 310 176H342C343.105 176 344 176.895 344 178V230C344 231.105 343.105 232 342 232H310C308.895 232 308 231.105 308 230V178Z",
    stroke: "#64A4D5",
    strokeWidth: 4
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M269 176H284C285.105 176 286 176.895 286 178V230C286 231.105 285.105 232 284 232H269V176Z",
    stroke: "#64A4D5",
    strokeWidth: 4
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M366 178C366 176.895 366.895 176 368 176H400C401.105 176 402 176.895 402 178V230C402 231.105 401.105 232 400 232H368C366.895 232 366 231.105 366 230V178Z",
    stroke: "#64A4D5",
    strokeWidth: 4
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M269 102H400C401.105 102 402 102.895 402 104V156C402 157.105 401.105 158 400 158H269V102Z",
    stroke: "#64A4D5",
    strokeWidth: 4
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 269,
    y1: 58,
    x2: 269,
    y2: 327,
    stroke: "#64A4D5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M269 252C269 250.895 269.895 250 271 250H400C401.105 250 402 250.895 402 252V294C402 295.105 401.105 296 400 296H271C269.895 296 269 295.105 269 294V252Z",
    stroke: "#64A4D5",
    strokeWidth: 4
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M57 90C57 88.3431 58.3431 87 60 87H94C95.6569 87 97 88.3431 97 90C97 91.6569 95.6569 93 94 93H60C58.3431 93 57 91.6569 57 90Z",
    fill: "#DAE9F5",
    fillOpacity: 0.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M57 101C57 99.3431 58.3431 98 60 98H84C85.6569 98 87 99.3431 87 101C87 102.657 85.6569 104 84 104H60C58.3431 104 57 102.657 57 101Z",
    fill: "#DAE9F5",
    fillOpacity: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M57 118C57 116.343 58.3431 115 60 115H84C85.6569 115 87 116.343 87 118C87 119.657 85.6569 121 84 121H60C58.3431 121 57 119.657 57 118Z",
    fill: "#ABB8CB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 73,
    width: 159,
    height: 239,
    fill: "url(#paint1_linear_1112_916)",
    fillOpacity: 0.24
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1112_916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67 304C67 299.582 70.5817 296 75 296H115C119.418 296 123 299.582 123 304V344C123 348.418 119.418 352 115 352H75C70.5817 352 67 348.418 67 344V304Z",
    fill: "#64A4D5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1112_916)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5437 340.945C79.5437 341.528 80.0159 342 80.5984 342H86.7119C87.2944 342 87.7666 341.528 87.7666 340.945V330.783C87.7666 330.2 87.2944 329.728 86.7119 329.728H80.5984C80.0159 329.728 79.5437 330.2 79.5437 330.783V340.945ZM81.6531 339.891V331.837H85.6572V339.891H81.6531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8887 340.945C90.8887 341.528 91.3609 342 91.9434 342H98.0569C98.6394 342 99.1116 341.528 99.1116 340.945V325.102C99.1116 324.52 98.6394 324.047 98.0569 324.047H91.9434C91.3609 324.047 90.8887 324.52 90.8887 325.102V340.945ZM92.998 339.891V326.157H97.0022V339.891H92.998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.233 340.945C102.233 341.528 102.706 342 103.288 342H109.402C109.984 342 110.456 341.528 110.456 340.945V316.523C110.456 315.94 109.984 315.468 109.402 315.468H103.288C102.706 315.468 102.233 315.94 102.233 316.523V340.945ZM104.343 339.891V317.577H108.347V339.891H104.343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7337 318.696C80.0048 319.211 80.6425 319.409 81.1581 319.138L92.1737 313.346L96.5583 315.619C96.8729 315.782 97.2483 315.776 97.5577 315.604L109.847 308.746C110.355 308.462 110.538 307.82 110.254 307.311C109.97 306.802 109.327 306.62 108.819 306.904L97.0254 313.485L92.6557 311.22C92.3494 311.061 91.9848 311.062 91.6794 311.223L80.1763 317.271C79.6608 317.542 79.4626 318.18 79.7337 318.696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.562 312.504C108.107 312.71 108.716 312.436 108.922 311.892L110.319 308.208C110.429 307.918 110.406 307.594 110.255 307.323C110.105 307.051 109.843 306.86 109.539 306.799L105.628 306.02C105.057 305.906 104.502 306.277 104.388 306.848C104.274 307.42 104.645 307.975 105.216 308.089L107.905 308.625L106.95 311.144C106.743 311.689 107.018 312.298 107.562 312.504Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1112_916",
    x: 84,
    y: 73,
    width: 207,
    height: 287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1112_916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1112_916",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1112_916",
    x: 19,
    y: 272,
    width: 152,
    height: 152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1112_916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1112_916",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1112_916",
    x1: 267,
    y1: 192,
    x2: 427,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE9F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1112_916",
    x1: 268,
    y1: 192,
    x2: 427,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64A4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64A4D5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clip-path", {
    id: "clip0_1112_916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(77 306)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeProvideQualitySection);
export default __webpack_public_path__ + "static/media/we-provide-quality-section.66d6f1ae04116a50dd78015b1117aabd.svg";
export { ForwardRef as ReactComponent };